/**
 * @generated SignedSource<<ec5246b9c17e3c1750eea4af42d373ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CompleteConfigurationTaskPayload",
    "kind": "LinkedField",
    "name": "completeConfigurationTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigurationTask",
        "kind": "LinkedField",
        "name": "configurationTask",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completion",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompleteConfigurationTaskMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompleteConfigurationTaskMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "22df6a2fcabc197ac35ecacdeb157099",
    "id": null,
    "metadata": {},
    "name": "CompleteConfigurationTaskMutation",
    "operationKind": "mutation",
    "text": "mutation CompleteConfigurationTaskMutation(\n  $input: CompleteConfigurationTaskInput!\n) {\n  completeConfigurationTask(input: $input) {\n    configurationTask {\n      id\n      completion\n    }\n  }\n}\n"
  }
};
})();

node.hash = "9c97330c089700e8400ffc4e769880f0";

module.exports = node;
